import script from "./AddQna.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddQna.vue?vue&type=script&setup=true&lang=ts"

import "./AddQna.vue?vue&type=style&index=0&id=a25bfc36&scope=true&lang=css"

const __exports__ = script;

export default __exports__